module.exports = __webpack_public_path__ + "static/media/availability_comparative_per_day.436cf417.svg";